"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
import { Menu, X, Search } from "lucide-react";
import { Input } from "@/components/ui/input";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const filteredMenuItems = menuItems.filter(item => !(item.label.includes("Terms") && item.label.includes("Service") || item.label.includes("Privacy") && item.label.includes("Policy")));
  if (loading) {
    return <div className="hidden md:flex gap-1">
        <div className="h-9 w-16 bg-muted-light animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted-light animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted-light animate-pulse rounded-md" />
      </div>;
  }
  return <>
      <NavigationMenu viewport={false} className="hidden md:flex">
        <NavigationMenuList className="gap-2">
          {filteredMenuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="relative inline-flex items-center px-4 py-2 text-sm font-medium text-foreground transition-all duration-300 hover:!bg-transparent focus:!bg-transparent before:absolute before:bottom-0 before:left-0 before:h-0.5 before:w-0 before:bg-primary before:transition-all before:duration-300 hover:before:w-full">
                  {item.label}
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      <Button variant="ghost" size="icon" className="md:hidden hover:!bg-transparent focus:!bg-transparent" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu">
        {mobileMenuOpen ? <X className="size-5" /> : <Menu className="size-5" />}
      </Button>

      {mobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-background border-b shadow-medium md:hidden animate-fade-in-up">
          <nav className="container mx-auto px-4 py-4 flex flex-col gap-2">
            {filteredMenuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="px-4 py-3 text-sm font-medium text-foreground hover:bg-accent hover:text-foreground rounded-md transition-all" onClick={() => setMobileMenuOpen(false)}>
                {item.label}
              </Link>)}
          </nav>
        </div>}

      <div className="flex items-center gap-2">
        {searchOpen ? <Input type="search" placeholder="Search..." className="w-32 sm:w-48 h-9 text-sm animate-fade-in-up" autoFocus onBlur={() => setSearchOpen(false)} /> : <Button variant="ghost" size="icon" className="hover:!bg-transparent focus:!bg-transparent" onClick={() => setSearchOpen(true)} aria-label="Search">
            <Search className="size-5" />
          </Button>}

        <Button asChild className="hidden sm:inline-flex bg-primary text-foreground hover:bg-primary-hover hover:!bg-primary-hover focus:!bg-primary hover:scale-[1.03] transition-all duration-300 shadow-soft hover:shadow-medium">
          <Link to="/#contact">Contact us</Link>
        </Button>
      </div>
    </>;
}
export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header className={`sticky top-0 z-50 w-full bg-background/95 backdrop-blur-sm border-b transition-all duration-300 ${scrolled ? "h-16 shadow-soft" : "h-[88px]"}`}>
      <div className="container mx-auto px-4 h-full flex items-center justify-between gap-4">
        <Link to="/#" className="flex-shrink-0 transition-all duration-300 hover:scale-105">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1510319/img/cashhome_brand_logo.png" alt="CashHome" className="h-8 drop-shadow-md transition-all duration-300 hover:drop-shadow-lg" />
        </Link>

        <MenuProvider menu_id="12" className="flex items-center gap-4 ml-auto">
          <HeaderMenuConsumer />
        </MenuProvider>
      </div>
    </header>;
}